import {
  CheckboxGroup,
  CheckboxLabel,
  ContainerTipoInteresse,
  Label,
} from "../styles";
import Stack from "@mui/material/Stack";
import { useEffect, useState } from "react";
import { Input } from "antd";
import { Interesses } from "../../../interfaces/Interesses";

interface TipoInteresseProps {
  interesseSelecionado?: Partial<Interesses>;
  objetivos: any[];
  setObjetivos: React.Dispatch<React.SetStateAction<any[]>>;
  origem: string;
  setOrigem: React.Dispatch<React.SetStateAction<string>>;
  quantidadePessoas: number;
  setQuantidadePessoas: React.Dispatch<React.SetStateAction<number>>;
  setBloquearBtn: (btn: boolean) => void;
}

export default function TipoInteresse({
  interesseSelecionado,
  objetivos,
  setObjetivos,
  origem,
  setOrigem,
  quantidadePessoas,
  setQuantidadePessoas,
  setBloquearBtn,
}: TipoInteresseProps) {
  const handleObjetivoChange = (value: string, checked: boolean) => {
    if (checked) {
      setObjetivos((prev) => [...prev, value]);
    } else {
      setObjetivos((prev) => prev.filter((item) => item !== value));
    }
  };

  // Scroll para o topo
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Preencher valores vindos do interesseSelecionado
  useEffect(() => {
    if (interesseSelecionado) {
      // objetivos (se alugar = 1 e trocar = 1, adiciona os dois)
      const novosObjetivos: string[] = [];
      if (interesseSelecionado.alugar) novosObjetivos.push("alugar");
      if (interesseSelecionado.trocar) novosObjetivos.push("trocar");
      setObjetivos(novosObjetivos);

      // capacidade (quantidade de pessoas)
      if (interesseSelecionado.capacidade) {
        setQuantidadePessoas(interesseSelecionado.capacidade);
      }

      // origem (se existir no backend)
      if (interesseSelecionado.origem) {
        setOrigem(interesseSelecionado.origem);
      }
    }
  }, [interesseSelecionado, setObjetivos, setQuantidadePessoas, setOrigem]);

  // Bloquear ou desbloquear botão
  useEffect(() => {
    const valido =
      objetivos.length > 0 &&
      quantidadePessoas > 0 &&
      (origem?.trim() || "") !== "";

    setBloquearBtn(!valido);
  }, [objetivos, quantidadePessoas, origem, setBloquearBtn]);

  return (
    <Stack spacing={1} direction="column">
      <ContainerTipoInteresse>
        <Label>Como pagaria pela estadia? (pode ser mais de uma opção)</Label>

        <CheckboxGroup>
          <CheckboxLabel>
            <input
              type="checkbox"
              name="objetivo"
              value="alugar"
              checked={objetivos.includes("alugar")}
              onChange={(e) => handleObjetivoChange("alugar", e.target.checked)}
            />
            Pagaria pelo período (alugar)
          </CheckboxLabel>

          <CheckboxLabel>
            <input
              type="checkbox"
              name="objetivo"
              value="trocar"
              checked={objetivos.includes("trocar")}
              onChange={(e) => handleObjetivoChange("trocar", e.target.checked)}
            />
            Trocaria por período que tenho disponível
          </CheckboxLabel>
        </CheckboxGroup>

        <Label>Quantas pessoas irão?</Label>
        <select
          value={quantidadePessoas || ""}
          onChange={(e) => setQuantidadePessoas(parseInt(e.target.value))}
          required
          style={{
            width: "100%",
            padding: "0.9rem",
            marginBottom: "1.5rem",
            borderRadius: "6px",
            border: "1px solid #ccc",
            fontSize: "1rem",
          }}
        >
          <option value="">Selecione</option>
          {[...Array(10)].map((_, i) => (
            <option key={i + 1} value={i + 1}>
              {i + 1} pessoa{i > 0 ? "s" : ""}
            </option>
          ))}
        </select>

        <Label>De qual cidade você pretende sair?</Label>
        <Input
          type="text"
          placeholder="Ex: São Paulo"
          value={origem}
          onChange={(e) => setOrigem(e.target.value)}
          required
        />
      </ContainerTipoInteresse>
    </Stack>
  );
}
